import Notification16 from '@carbon/icons-react/es/notification/16';
import React, { FC } from 'react';
import { Section } from './section';

export const Everything: FC = () => (
  <Section
    group="everything"
    icon={<Notification16 />}
    configurations={[]}
    onChange={() => {}}
    showHeaders
  />
);
